export default __webpack_public_path__ + "static/media/businesscard.efffb6c4.png";